import React, { useEffect, useRef, useState } from "react";
import { Button } from "./button";
import { Label } from "./label";

/**
 * Modal de comentário obrigatório
 */
export default function CommentModal({
  open,
  title = "Comentário obrigatório",
  subtitle = "",
  defaultValue = "",
  onConfirm,
  onCancel,
}) {
  const [text, setText] = useState(defaultValue || "");
  const ref = useRef(null);
  const textRef = useRef("");

  // manter ref sempre atualizado para atalhos de teclado
  useEffect(() => {
    textRef.current = text;
  }, [text]);

  // resetar campo e focar somente quando abrir ou quando defaultValue mudar
  useEffect(() => {
    if (!open) return;
    setText(defaultValue || "");
    // foco assíncrono para garantir montagem
    const t = setTimeout(() => ref.current?.focus(), 0);
    return () => clearTimeout(t);
  }, [open, defaultValue]);

  // atalhos de teclado globais enquanto o modal está aberto
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onCancel?.();
        return;
      }
      if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
        const val = (textRef.current || "").trim();
        if (val) {
          e.preventDefault();
          onConfirm?.(val);
        }
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onCancel, onConfirm]);

  if (!open) return null;

  return (
    <div className="drawer" role="dialog" aria-modal="true" onClick={onCancel}>
      <div
        className="drawer-body"
        style={{ maxWidth: 560 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="drawer-header">
          <h2>{title}</h2>
          <Button variant="ghost" onClick={onCancel}>
            Fechar
          </Button>
        </div>

        {subtitle ? (
          <div style={{ marginBottom: 8, color: "#64748b" }}>{subtitle}</div>
        ) : null}

        <div className="grid grid-1">
          <div>
            <Label>Descreva o motivo</Label>
            <textarea
              ref={ref}
              className="input native"
              rows={8}
              placeholder="Digite o motivo da mudança de status… (Ctrl+Enter para confirmar)"
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </div>
        </div>

        <div className="flex justify-end mt-3" style={{ gap: 8 }}>
          <Button variant="secondary" onClick={onCancel}>
            Cancelar
          </Button>
          <Button onClick={() => text.trim() && onConfirm?.(text.trim())}>
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  );
}
